import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './NewsDetail.css';

const NewsDetail = () => {
    const { id } = useParams();
    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchNewsDetail();
    }, [id]);

    const fetchNewsDetail = async () => {
        try {
            // Replace this URL with your actual backend API endpoint
            const response = await fetch(`http://localhost:8080/api/news/${id}`);

            if (!response.ok) {
                throw new Error('Failed to fetch news detail');
            }

            const data = await response.json();
            setArticle(data);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);

            // Mock data for demonstration
            const mockArticles = {
                '1': {
                    id: 1,
                    title: 'Welcome to Your News Site',
                    content: `
                        <p>Welcome to your new news site! This is a demonstration article showing how the news detail page works.</p>
                        <p>This page displays the full content of a news article. You can customize the layout and styling to match your needs.</p>
                        <h2>Features</h2>
                        <ul>
                            <li>Responsive design</li>
                            <li>Clean and modern layout</li>
                            <li>Easy navigation back to home</li>
                            <li>Backend API integration ready</li>
                        </ul>
                        <p>To connect to your real backend, update the API endpoint in the NewsDetail.js component.</p>
                    `,
                    date: '2025-11-30',
                    author: 'Admin'
                },
                '2': {
                    id: 2,
                    title: 'Getting Started',
                    content: `
                        <p>This article explains how to configure your news site to connect to a backend service.</p>
                        <h2>Configuration Steps</h2>
                        <ol>
                            <li>Update the API endpoint in <code>NewsList.js</code></li>
                            <li>Update the API endpoint in <code>NewsDetail.js</code></li>
                            <li>Ensure your backend returns the correct JSON format</li>
                            <li>Test the connection</li>
                        </ol>
                        <p>The expected JSON format for news list:</p>
                        <pre>
[
  {
    "id": 1,
    "title": "Article Title",
    "summary": "Brief summary",
    "date": "2025-11-30",
    "author": "Author Name"
  }
]
                        </pre>
                    `,
                    date: '2025-11-29',
                    author: 'System'
                },
                '3': {
                    id: 3,
                    title: 'Sample News Article',
                    content: `
                        <p>This is a sample article demonstrating the news detail page layout.</p>
                        <p>You can include various types of content here:</p>
                        <h2>Text Content</h2>
                        <p>Regular paragraphs with text content...</p>
                        <h2>Lists</h2>
                        <ul>
                            <li>Item one</li>
                            <li>Item two</li>
                            <li>Item three</li>
                        </ul>
                        <h2>Quotes</h2>
                        <blockquote>
                            "This is a quote example that can be included in your articles."
                        </blockquote>
                    `,
                    date: '2025-11-28',
                    author: 'Editor'
                }
            };

            setArticle(mockArticles[id] || {
                id: id,
                title: 'Article Not Found',
                content: '<p>The requested article could not be found.</p>',
                date: '2025-11-30',
                author: 'System'
            });
        }
    };

    if (loading) {
        return <div className="news-detail-loading">Loading article...</div>;
    }

    if (!article) {
        return (
            <div className="news-detail-error">
                <h1>Article Not Found</h1>
                <Link to="/" className="back-link">← Back to Home</Link>
            </div>
        );
    }

    return (
        <div className="news-detail-container">
            <Link to="/" className="back-link">← Back to Home</Link>

            <article className="news-article">
                <header className="article-header">
                    <h1>{article.title}</h1>
                    <div className="article-meta">
                        <span className="article-date">{article.date}</span>
                        {article.author && (
                            <span className="article-author"> • By {article.author}</span>
                        )}
                    </div>
                </header>

                <div
                    className="article-content"
                    dangerouslySetInnerHTML={{ __html: article.content }}
                />
            </article>

            {error && (
                <div className="api-note">
                    <p>Note: Displaying demo content. Configure your backend API endpoint at: <code>http://localhost:8080/api/news/{id}</code></p>
                </div>
            )}
        </div>
    );
};

export default NewsDetail;
